import { useState } from 'react';
import { SortState } from '../components/SortIcon';

export function useSort(initial: SortState): [SortState, (col: string) => void, () => void] {
  const [sort, setSort] = useState<SortState>(initial);
  const handleSort = (col: string) =>
    setSort((s) => s.col === col ? { col, dir: s.dir === 'asc' ? 'desc' : 'asc' } : { col, dir: 'asc' });
  const resetSort = () => setSort(initial);
  return [sort, handleSort, resetSort];
}
